import classNames from 'classnames';
import { forwardRef } from 'react';

export interface TableBodyProps {
  className?: string;
}

export const TableBody = forwardRef<HTMLTableSectionElement, React.PropsWithChildren<TableBodyProps>>(
  ({ className, children }, ref) => {
    return (
      <tbody
        ref={ref}
        className={classNames('divide-y border-border dark:divide-gray-900 dark:bg-gray-800', className)}
      >
        {children}
      </tbody>
    );
  },
);

export default TableBody;
